import styled from 'fe-styled-components';
import theme from 'fe-appdir-lib-theme';

const BUTTON_WIDTH = '64px';
const BUTTON_HEIGHT = '64px';

const CarouselButton = styled.button`
  position: absolute;
  top: 150px;
  width: ${BUTTON_WIDTH};
  height: ${BUTTON_HEIGHT};
  margin: 0;
  border: 2px solid #e5e6e7;
  border-radius: 2px;
  padding: 0;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
  background: ${theme.colorBlack};
  transition: 0.1s background ease-in;

  &:hover {
    background: ${theme.colorBase};
  }

  &:focus {
    border: 2px solid ${theme.colorBrandPrimary};
    outline: none;
  }

  &:active {
    background: ${theme.colorBlack};
  }

  &:disabled {
    background: ${theme.colorGrey60};
  }

  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;

const CarouselPreviousButton = styled(CarouselButton)`
  transform: translate3d(calc(-${theme.spacingLg} - ${BUTTON_WIDTH}), -50%, 0);
`;

const CarouselNextButton = styled(CarouselButton)`
  transform: translate3d(${theme.spacingLg}, -50%, 0);
`;

export { CarouselPreviousButton, CarouselNextButton };
